export interface Test {

  endTest: (successful: boolean, message?: string) => void
  startTest: () => Promise<void>

  resultElement: HTMLLIElement
  testState: testStates
  isCritical: boolean
  name: string
  testMethod: (candidate: RTCIceCandidate) => boolean
}

export enum testStates {
  'not started',
  'running',
  'failed',
  'succeded'
}
